<script setup>
import {useTemplateRef} from 'vue'

//Emits and props
defineProps({
  tag: {
    type: String,
    default: 'div',
  },
})

//Expose form ref
const form = useTemplateRef('form')
defineExpose({form})
</script>

<template>
  <component
    :is="tag"
    ref="form"
    :class="$style.form"
    v-bind="$attrs"
  >
    <slot />

    <div :class="$style.buttons">
      <slot name="buttons" />
    </div>
  </component>
</template>

<style module>
.form {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
}
.buttons {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 0.5rem;
  margin-top: 1rem;
}
</style>
